import { render, staticRenderFns } from "./testStepper.vue?vue&type=template&id=2b457f58&scoped=true&"
import script from "./testStepper.vue?vue&type=script&lang=js&"
export * from "./testStepper.vue?vue&type=script&lang=js&"
import style0 from "./testStepper.vue?vue&type=style&index=0&id=2b457f58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b457f58",
  null
  
)

export default component.exports